"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelTemplateContent_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var LabelTemplateContent_Factory = /** @class */ (function () {
    function LabelTemplateContent_Factory() {
    }
    LabelTemplateContent_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            LabelTemplateId: model.LabelTemplateId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TemplateContent: model.TemplateContent,
        };
        return result;
    };
    LabelTemplateContent_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            LabelTemplateId: model.LabelTemplateId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TemplateContent: model.TemplateContent,
        };
        return result;
    };
    return LabelTemplateContent_Factory;
}());
exports.LabelTemplateContent_Factory = LabelTemplateContent_Factory;
